import { Button, Grid, Input, Popup } from "semantic-ui-react";

import { DispositionButton } from "routes/dial_sessions/components/DispositionButton";

import style from "routes/dial_sessions/components/CallDispositionPopup.module.scss";

export function CallDispositionPopup({
  disposition,
  onSetDispositionId,
  dispositionId,
  setDispositionComment,
  dispositionComment,
  disabled = false,
}) {
  const handleClick = (_, { value }) => {
    onSetDispositionId(value.id);
  };

  const handleCommentChange = (parentDisposition, comment) => {
    onSetDispositionId(parentDisposition.id);
    setDispositionComment(comment);
  };

  if (disposition.child_dispositions.length === 0) {
    return (
      <DispositionButton
        disabled={disabled}
        disposition={disposition}
        dispositionId={dispositionId}
        handleClick={handleClick}
      />
    );
  }

  return (
    <Popup
      className={style.popup}
      style={{ width: "100px" }}
      trigger={
        <Button
          size="tiny"
          disabled={disabled}
          content={disposition.displayName}
          className={
            !!disposition.child_dispositions.find(
              d => d.id === dispositionId
            ) || disposition.id === dispositionId
              ? "gray"
              : "white"
          }
        />
      }
      on="click"
      content={
        <Grid relaxed centered className="keys">
          {disposition.child_dispositions.map(d => (
            <Grid.Row key={d.id}>
              <DispositionButton
                disposition={d}
                dispositionId={dispositionId}
                handleClick={handleClick}
                disabled={disabled}
              />
            </Grid.Row>
          ))}
          <Grid.Row key={`${disposition.id}-other`}>
            <Button
              size="tiny"
              value={disposition}
              onClick={(_, data) => {
                handleClick(_, data);
                if (dispositionId !== disposition.id) {
                  setDispositionComment("");
                }
              }}
              content="Other"
              className={`${
                dispositionId === disposition.id ? "gray" : "white"
              } disposition`}
            />
          </Grid.Row>
          <Grid.Row>
            <Input
              className="disposition"
              placeholder="comment..."
              name="other_comment"
              value={dispositionId === disposition.id ? dispositionComment : ""}
              onChange={e => handleCommentChange(disposition, e.target.value)}
            />
          </Grid.Row>
        </Grid>
      }
    />
  );
}
